<template>
    <nav>
        <section id="menu" class="sf-normal">
            <ul>
                <!--if this page is current page, add class 'active' in this <li>-->
                <li :class="{ active: division == 'invoice' }">
                    <router-link to="/invoice">
                        <i class="fas fa-receipt nav-icon bc05"></i>
                        <span>인보이스 관리</span>
                    </router-link>
                </li>
                <li :class="{ active: division == 'document' }">
                    <router-link to="/document">
                        <i class="fas fa-paper-plane nav-icon bc06"></i>
                        <span>신청서 관리</span>
                    </router-link>
                </li>
                <li :class="{ active: division == 'license' }" v-if="appr !== 'Y'">
                    <router-link to="/license">
                        <i class="fas fa-paperclip nav-icon bc03"></i>
                        <span>허가증 관리</span>
                    </router-link>
                </li>
                <li :class="{ active: (division == 'item' || subMenu == 3) }" v-if="appr !== 'Y'">
                    <div @click="openMenu(3, $event)">
                        <i class="fas fa-cube nav-icon bc04"></i>
                        <span>품목 관리</span>
                    </div>
                    <transition name="fade">
                        <ul class="nav-dropdown" v-show="subMenu === 3">
                            <li><router-link to="/item/item">품목 관리</router-link></li>
                            <li><router-link to="/item/upn">미등록 품목 관리</router-link></li>
                            <li><router-link to="/item/trust">제조자 고정품목 관리</router-link></li>
                            <li><router-link to="/item/unitprice">단가 관리</router-link></li>
                        </ul>
                    </transition>
                </li>
                <li :class="{ active: (division == 'code' || subMenu == 1) }" v-if="appr !== 'Y'">
                    <div @click="openMenu(1, $event)">
                        <i class="fas fa-plus nav-icon bc01"></i>
                        <span>코드 관리</span>
                    </div>
                    <transition name="fade">
                        <ul class="nav-dropdown" v-show="subMenu === 1">
                            <li><router-link to="/code/standard">표준코드 관리</router-link></li>
                            <li><router-link to="/code/general">일반코드 관리</router-link></li>
                            <li><router-link to="/code/division">분류번호 관리</router-link></li>
                        </ul>
                    </transition>
                </li>
                <li :class="{ active: (division == 'company' || subMenu == 4) }" v-if="appr !== 'Y'">
                    <div @click="openMenu(4, $event)">
                        <i class="fas fa-wrench nav-icon bc02"></i>
                        <span>업체 관리</span>
                    </div>
                    <transition name="fade">
                        <ul class="nav-dropdown" v-show="subMenu === 4">                            
                            <li><router-link to="/company/importer">수입자 관리</router-link></li>
                            <li><router-link to="/company/exporter">수출자 관리</router-link></li>
                        </ul>
                    </transition>
                </li>
                <li :class="{ active: division == 'stats' || subMenu == 2 }" v-if="appr !== 'Y'">
                    <router-link to="/stats/document">
                        <i class="fas fa-chart-bar nav-icon bc07"></i>
                        <span>승인 현황</span>
                    </router-link>
                </li>
            </ul>
        </section>
        <section id="navigator" class="sf-normal pull-right">
            <ul>
                <li>
                    <router-link to="/"><i class="fas fa-home"></i></router-link>
                </li>
                <li :class="{ current: itemName === null }">
                    <router-link to="/">{{ divisionName }}</router-link>
                </li>
                <li class="current" v-if="itemName">
                    <router-link to="/">{{ itemName }}</router-link>
                </li>
            </ul>
        </section>
    </nav>
</template>
<script>
import $ from 'jquery'
export default {
    data: () => ({
        subMenu: 0,
        division: window.location.pathname.split('/').filter(Boolean)[0],
        divisionName: '',
        itemName: null,
        appr: sessionStorage.getItem('dvApprYN1')
    }),
    watch: {
        '$route'() {
            this.setNavigation()
            // route가 바뀔 때 subMenu 초기화
            this.subMenu = 0
        }
    },
    created() {
        /*해당 소스는 문서의 !user-group 부분을 참조함*/
        /*팀명에 따라 색상을 구분 할 의도로 작성*/
        /*추후 적절한 구분 로직의 재 정리가 필요함*/
        var userGroup = $('.user-info .user-group').text()
        if(userGroup.length <= 3 ) {
            $('.user-icon').addClass('bc01');
        }
        if(userGroup.length == 4 ) {
            $('.user-icon').addClass('bc02');
        }
        if(userGroup.length == 5 ) {
            $('.user-icon').addClass('bc03');
        }
        if(userGroup.length == 6 ) {
            $('.user-icon').addClass('bc04');
        }
        if(userGroup.length == 7 ) {
            $('.user-icon').addClass('bc05');
        }
        if(userGroup.length == 8 ) {
            $('.user-icon').addClass('bc06');
        }
        if(userGroup.length >= 9 ) {
            $('.user-icon').addClass('bc07');
        }
        this.setNavigation()
    },
    methods: {
        openMenu(menuNum, event) {
            if (event.target.tagName === 'A') {
                return
            }
            if (this.subMenu == menuNum)
                menuNum = 0
            this.subMenu = menuNum
        },
        setNavigation() {
            let item,
                pathname,
                pathgroup,
                itemgroup

            pathgroup = {
                code: '코드 관리',
                config: '환경설정',
                license: '허가증 관리',
                item: '품목 관리',
                invoice: '인보이스 관리',
                document: '신청서 관리',
                stats: '현황 관리',
                company: '업체 관리',
            }
            
            itemgroup = {
                standard: '표준코드 관리',
                general: '일반코드 관리',
                division: '분류번호 관리',
                unitprice: '단가 관리',
                upn: '미등록 품목 관리',
                trust: '제조자 고정품목 관리',
                importer: '수입자 관리',
                exporter: '수출자 관리',
                document: '문서 관리',
                license: '허가증 관리',
                item: '품목 관리',
            }

            pathname = window.location.pathname.split('/').filter(Boolean)
            this.division = pathname[0]
            this.divisionName = pathgroup[pathname[0]]
            item = pathname[1]

            if (item !== undefined) {
                this.itemName = itemgroup[pathname[1]]
                // this.itemName = pathname[1]
            } else {
                this.itemName = null
            }
        }
    }
}
</script>

<style>
    @import "../../../assets/plugin/fontawesome/css/all.min.css";

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s ease;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/template/menu.vue